import {
  Alignment,
  Button,
  ButtonGroup,
  ButtonWithDialog,
  Classes,
  Dialog,
  Icon,
  Popover,
  Position,
} from "@focus/focusUI";
import { useState } from "react";
import { VersioningInfoContainer } from "../../containers/VersioningInfoContainer";
import { HeaderHelpDialog } from "../HeaderHelpDialog";
import { QuestionnaireForm } from "../QuestionnaireForm";
import "./HeaderHelpButton.scss";
import { sendQuestionnarie } from "../../services/questionnaires";

const NUNTIARE_URL = "https://nuntiare.gmv.com/";

export const HeaderHelpButton = () => {
  const [versioningOpen, setVersioningOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <>
      <Popover
        popoverClassName={`${Classes.POPOVER_CONTENT_SIZING} header-help-popover`}
        portalClassName="header-help-popover-portal"
        position={Position.BOTTOM_RIGHT}
        usePortal={process.env.NODE_ENV !== "test"}
      >
        <Button
          className="header-help-button"
          minimal
          icon={<Icon icon="info-sign" title={false} />}
        />

        <ButtonGroup minimal={true} vertical={true} alignText={Alignment.LEFT}>
          <Button
            className="header-help-button-dialog"
            minimal
            text="Versioning info"
            icon="book"
            onClick={() => setVersioningOpen(true)}
          />
          <ButtonWithDialog
            className="header-help-button-dialog"
            style={{
              width: "min(1100px, calc(100vw - 3rem))",
              maxWidth: "1100px",
              minHeight: "80vh",
            }}
            minimal
            text="Help and Manuals"
            tooltipText="Help and Manuals"
            intent="none"
            icon="help"
            headerTitle="Help and Manuals"
            form={() => <HeaderHelpDialog />}
            hideButtons
            onAccept={() => {}}
          />
          <Button
            className="header-help-button-dialog"
            minimal
            text="Support"
            icon="share"
            onClick={() => window.open(NUNTIARE_URL, "_blank")}
          />
          <Button
            className="header-help-button-dialog"
            minimal
            text="Contact Us"
            icon="envelope"
            onClick={() => setContactOpen(true)}
          />
        </ButtonGroup>
      </Popover>

      <Dialog
        canEscapeKeyClose
        canOutsideClickClose
        icon="book"
        isOpen={versioningOpen}
        onClose={() => setVersioningOpen(false)}
        title="Versioning Info"
      >
        <div className="bp4-dialog-body">
          <VersioningInfoContainer />
        </div>
      </Dialog>

      <Dialog
        canEscapeKeyClose
        canOutsideClickClose
        className="header-help-contact-dialog"
        icon="envelope"
        isOpen={contactOpen}
        onClose={() => setContactOpen(false)}
        title="Contact Us"
      >
        <div className="bp4-dialog-body header-help-contact-dialog-body">
          <QuestionnaireForm
            handleSubmit={sendQuestionnarie}
            title="Contact us"
            reason="Use this form to send a structured inquiry to the Space Safety Portal team."
            initialData={{
              email: "",
              message: "",
              name: "",
              organization: "",
              service: "",
            }}
            contactServiceOptions={[]}
            hideService
          />
        </div>
      </Dialog>
    </>
  );
};
